(() => {
  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => {
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
  };

  // src/js/components/collapse.js
  var _Collapse = class {
    constructor(container, items, param) {
      this.container = container;
      this.items = items;
      this.param = param;
    }
    static create(params) {
      const selector = params?.selector ?? _Collapse.param.selector;
      const groups = document.querySelectorAll(selector);
      let objects = [];
      groups.forEach((group) => {
        let itemsObj = [];
        const items = group.querySelectorAll(_Collapse.param.itemSelector);
        const param = {
          modifiers: {
            active: "is-open",
            destroyed: "is-destroyed"
          },
          ...group.dataset.collapseParam ? JSON.parse(group.dataset.collapseParam) : null
        };
        items.forEach((item) => {
          const itemButton = item.querySelector("button");
          const itemInner = item.querySelector(_Collapse.param.innerSelector) ?? itemButton.nextElementSibling;
          itemsObj.push({
            id: item.id,
            element: item,
            button: itemButton,
            inner: itemInner,
            state: false
          });
        });
        const obj = new _Collapse(group, itemsObj, param);
        obj.init();
        objects.push(obj);
      });
      return objects;
    }
    init() {
      const self = this;
      this.items.forEach((item) => {
        if (window.Store.app.responsive?.isBreakpointActive(self.param?.breakpoint)) {
          item.element.classList.add(self.param.modifiers.destroyed);
          item.button.disabled = true;
          item.inner.style.overflow = "visible";
        } else {
          item.inner.style.overflow = "hidden";
          self.setHeight(item, 0);
        }
        item.button.addEventListener("click", () => {
          self.toggle(item);
        });
      });
      if (this.param.toggleFirst) {
        setTimeout(() => {
          this.toggle(this.items[0]);
        }, 250);
      }
      return true;
    }
    toggle(itemToToggle) {
      this.items.filter((item) => item != itemToToggle).forEach((item) => {
        if (item.state) {
          item.state = false;
          item.element.classList.remove(this.param.modifiers.active);
          this.setHeight(item, 0);
        }
      });
      itemToToggle.element.classList.toggle(this.param.modifiers.active);
      itemToToggle.state = !itemToToggle.state;
      this.setHeight(itemToToggle, itemToToggle.state ? itemToToggle.inner.firstElementChild.scrollHeight : 0);
      return itemToToggle.state;
    }
    update() {
      const _this = this;
      this.items.forEach((item) => {
        if (!_this.param.breakpoint && item.state) {
          item.inner.firstElementChild.style.removeProperty("height");
          _this.setHeight(item, item.inner.firstElementChild.scrollHeight);
          return;
        }
        if (window.Store.app.responsive.isBreakpointActive(_this.param.breakpoint)) {
          item.state = false;
          item.element.classList.add(_this.param.modifiers.destroyed);
          item.element.classList.remove(_this.param.modifiers.active);
          item.button.disabled = true;
          item.inner.style.overflow = "visible";
          this.setHeight(item, item.inner.firstElementChild.scrollHeight);
        } else {
          item.element.classList.remove(_this.param.modifiers.destroyed);
          item.button.disabled = false;
          item.inner.style.overflow = "hidden";
          this.setHeight(item, item.state ? item.inner.firstElementChild.scrollHeight : 0);
        }
      });
      return true;
    }
    updateAfterDelay(delay = 1e3) {
      setTimeout(this.update.bind(this), delay);
    }
    setHeight(item, height) {
      if (item) {
        item.inner.firstElementChild.style.height = `${height}px`;
      }
      if (this.param.setParentHeight) {
        if (window.Store.app.responsive.isBreakpointActive(this.param?.setParentHeightBreakpoint)) {
          this.container.style.height = `${height > this.containerHeight ? height : this.containerHeight}px`;
        } else {
          this.container.style.removeProperty("height");
        }
      }
      window.Store.scrollbar.update();
      return true;
    }
    get containerHeight() {
      let elementsHeight = 0;
      let buttonsHeight = 0;
      this.items.forEach((item) => {
        elementsHeight += item.button.offsetHeight;
        buttonsHeight += item.inner.firstElementChild.offsetHeight;
      });
      return Math.max(buttonsHeight, elementsHeight);
    }
  };
  var Collapse = _Collapse;
  __publicField(Collapse, "param", {
    selector: ".js-collapse",
    itemSelector: ".js-collapseItem",
    innerSelector: ".js-collapseInner",
    modifiers: {}
  });
  function render() {
    window.Store.components.collapse.obj = Collapse.create();
  }
  window.Store.components.collapse.render = render;
})();
